module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.05 11.05h9.9v9.9h-9.9z\"></path></svg>"